<template>
<div class="modal fade" id="modalApplyRecalcPoints" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Configurações ESCALA — Recalcular pontos automaticamente</h4>
        <p class="subtitle-modal">
          Pode ser definido no nível da empresa e sobrescrito por turno individualmente
          (override).
        </p>

        <div class="alert-box">
          <strong>Atenção:</strong> quando ativo, o sistema <em>reprocessa</em>
          os pontos do colaborador toda vez que a escala é gerada. Isso inclui
          os pontos <strong>pré-assinalados</strong> — eles podem ser
          <u>removidos</u> se não fizerem mais sentido segundo a nova escala, e
          <u>recriados</u> nos horários ajustados. Use só em empresas que
          aceitam essa dinâmica, porque pode afetar fechamentos já consolidados
          e horas extras já registradas.
        </div>
      </div>

      <div class="modal-body">
        <div v-if="loadingModal" class="loading center_vertical">
          <div class="loader-mini-box">
            <div class="spinner-box">
              <div class="rect1"></div><div class="rect2"></div>
              <div class="rect3"></div><div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
        </div>

        <div v-if="!loadingModal">
          <!-- Empresa -->
          <div class="company-toggle">
            <label class="lbl-section">{{ labels.companySettings.applyRecalcPoints }} (Regras do ponto)</label>
            <div class="toggle-line">
              <label class="recalc-switch">
                <input type="checkbox" v-model="companyApplyRecalcPoints" />
                <span class="recalc-toggle-slider"></span>
              </label>
              <span class="toggle-state">{{ companyApplyRecalcPoints ? 'Sim' : 'Não' }}</span>
            </div>
          </div>

          <!-- Turnos -->
          <label class="lbl-section">Override por turno</label>
          <p class="hint">
            Deixe "Herdado" para usar o valor da empresa. Selecione Sim/Não para
            sobrescrever apenas nesse turno.
          </p>

          <div v-if="!workshifts.length" class="empty">Nenhum turno encontrado.</div>

          <div v-else class="workshift-search">
            <input type="text" v-model="workshiftFilter" placeholder="Buscar turno pelo nome..." />
            <span class="count">{{ filteredWorkshifts.length }} de {{ workshifts.length }} turno(s)</span>
          </div>

          <table v-if="workshifts.length" class="table-workshifts">
            <thead>
              <tr>
                <th>Turno</th>
                <th>Tipo</th>
                <th>Fuso</th>
                <th>{{ labels.workShift.applyRecalcPoints }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="ws in filteredWorkshifts" :key="ws.id">
                <td>{{ ws.name }}</td>
                <td>{{ helpers.getWorkShiftTypeLabel(ws.workShiftType) }}</td>
                <td>{{ helpers.formatInheritableTimezone(ws.timeZone, companyTimeZone) }}</td>
                <td>
                  <select v-model="overrides[ws.id]" class="override-select">
                    <option :value="null">Herdado ({{ companyApplyRecalcPoints ? 'Sim' : 'Não' }})</option>
                    <option :value="true">Sim</option>
                    <option :value="false">Não</option>
                  </select>
                </td>
              </tr>
              <tr v-if="!filteredWorkshifts.length">
                <td :colspan="4" class="empty-row">Nenhum turno encontrado para "{{ workshiftFilter }}".</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="modal-footer">
        <button v-if="!loadingModal" v-on:click="save()" :disabled="loadingSave"
                v-bind:class="{'disable': loadingSave}" type="submit" class="btn btn-register">
          <span v-if="!loadingSave">Salvar</span>
          <div class="loading-btn" v-else>
            <div class="spinner-btn">
              <div class="rect1"></div><div class="rect2"></div>
              <div class="rect3"></div><div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
        </button>
        <button v-on:click="closeModal()" class="close-btn">Fechar</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  APPLY_RECALC_POINTS,
  GET_WORKSHIFT_FULL_VIEW
} from "../../../urlConfig";
import { REQUEST_SERVICE } from "../../../requestConfig";
import { UTIL_SERVICE } from "../../../utils";
import {
  workShiftLabels,
  companySettingsLabels,
  labelHelpers
} from "../../../labels/workshiftLabels";
import swal from "sweetalert";

export default {
  name: "modalApplyRecalcPoints",
  props: ["dataCompanyModal"],
  data() {
    return {
      loadingModal: false,
      loadingSave: false,
      modalContext: "",
      companyId: "",
      companyTimeZone: "",
      companyApplyRecalcPoints: false,
      workshifts: [],
      workshiftFilter: "",
      overrides: {}, // { workshiftId: null | true | false }
      labels: {
        workShift: workShiftLabels,
        companySettings: companySettingsLabels
      },
      helpers: labelHelpers
    };
  },
  watch: {
    dataCompanyModal(val) {
      if (!val) return;
      this.modalContext = val.context;
      this.companyId = val.companyId || (this.$route && this.$route.params.idCompany);
      this.loadData();
    }
  },
  computed: {
    filteredWorkshifts() {
      const q = (this.workshiftFilter || "").trim().toLowerCase();
      if (!q) return this.workshifts;
      return this.workshifts.filter((w) => (w.name || "").toLowerCase().indexOf(q) !== -1);
    }
  },
  methods: {
    loadData() {
      this.loadingModal = true;
      REQUEST_SERVICE.requestContext(
        "GET",
        `${GET_WORKSHIFT_FULL_VIEW}?companyId=${this.companyId}`,
        this.modalContext
      ).then((response) => {
        UTIL_SERVICE.console("RESULT GET_WORKSHIFT_FULL_VIEW:", response.data);
        const data = response.data || {};
        this.companyTimeZone = data.defaultTimeZone || "";
        this.companyApplyRecalcPoints = !!data.applyRecalcPoints;
        this.workshifts = Array.isArray(data.workshifts) ? data.workshifts : [];
        this.workshiftFilter = "";

        const initialOverrides = {};
        this.workshifts.forEach((ws) => {
          initialOverrides[ws.id] = ws.applyRecalcPoints !== undefined ? ws.applyRecalcPoints : null;
        });
        this.overrides = initialOverrides;
        this.loadingModal = false;
      }).catch(() => {
        this.loadingModal = false;
        swal("Aviso", "Falha ao carregar turnos da empresa.", "error");
      });
    },
    closeModal() {
      $("#modalApplyRecalcPoints").modal("toggle");
    },
    save() {
      if (this.loadingSave) return;
      this.loadingSave = true;

      // Envia apenas overrides explícitos (ignora "herdado" se nunca foi mexido).
      const workshiftOverrides = this.workshifts
        .map((ws) => ({
          workshiftId: ws.id,
          applyRecalcPoints: this.overrides[ws.id] === undefined ? null : this.overrides[ws.id]
        }))
        // só envia turnos onde o valor mudou ou onde já havia override prévio
        .filter((o) => o.applyRecalcPoints !== null || this._hadOverride(o.workshiftId));

      const payload = {
        companyId: this.companyId,
        companyApplyRecalcPoints: this.companyApplyRecalcPoints,
        workshiftOverrides: workshiftOverrides
      };

      REQUEST_SERVICE.requestContext("PUT", APPLY_RECALC_POINTS, this.modalContext, payload)
        .then((response) => {
          UTIL_SERVICE.console("RESULT APPLY_RECALC_POINTS:", response);
          this.loadingSave = false;
          $("#modalApplyRecalcPoints").modal("toggle");
          swal("Aviso", "Configuração de recálculo de pontos atualizada.", "success");
        })
        .catch(() => {
          this.loadingSave = false;
          swal("Aviso", "Entre em contato com a equipe de DEV.", "error");
        });
    },
    _hadOverride(workshiftId) {
      const ws = this.workshifts.find((w) => w.id === workshiftId);
      return ws && ws.applyRecalcPoints !== null && ws.applyRecalcPoints !== undefined;
    }
  }
};
</script>

<style lang="scss">
#modalApplyRecalcPoints {
  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }
  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  .subtitle-modal {
    text-align: center;
    color: #777;
    font-size: 13px;
    margin-top: 8px;
    padding: 0 30px;
  }
  .alert-box {
    margin: 14px 30px 0;
    padding: 12px 14px;
    background: #fff7e1;
    border-left: 4px solid #f9ca04;
    color: #5a4a00;
    font-size: 12px;
    line-height: 1.45;
    border-radius: 4px;
    strong { color: #b87800; }
  }
  .modal-body {
    padding: 20px 40px;
  }
  .lbl-section {
    display: block;
    font-weight: 600;
    margin-bottom: 8px;
    margin-top: 16px;
    color: #333;
  }
  .hint {
    font-size: 12px;
    color: #888;
    margin: 0 0 12px 0;
  }
  .company-toggle .toggle-line {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .toggle-state {
    font-weight: 600;
  }
  // Classes "recalc-*" pra evitar colisão com .switch/.slider globais
  // (ion-rangeslider, bootstrap-switch, etc.) que sobrescrevem o toggle.
  .recalc-switch {
    position: relative !important;
    display: inline-block !important;
    width: 50px !important;
    height: 24px !important;
    margin: 0 !important;
    padding: 0 !important;
    vertical-align: middle;

    input {
      opacity: 0 !important;
      width: 0 !important;
      height: 0 !important;
      position: absolute !important;
      margin: 0 !important;
    }

    .recalc-toggle-slider {
      position: absolute !important;
      cursor: pointer;
      top: 0; left: 0; right: 0; bottom: 0;
      width: 50px;
      height: 24px;
      background-color: #ccc;
      transition: background-color 0.3s;
      border-radius: 24px;
      display: block;
    }
    .recalc-toggle-slider::before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 3px;
      bottom: 3px;
      background-color: #ffffff;
      transition: transform 0.3s;
      border-radius: 50%;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    }
    input:checked + .recalc-toggle-slider { background-color: #3598dc; }
    input:checked + .recalc-toggle-slider::before { transform: translateX(26px); }
  }
  .workshift-search {
    display: flex; align-items: center; gap: 10px; margin-bottom: 10px; flex-wrap: wrap;
    input {
      flex: 1 1 260px; min-width: 200px;
      border: 1px solid #ccc; border-radius: 4px; padding: 6px 10px; font-size: 13px;
    }
    .count { font-size: 12px; color: #888; }
  }
  .empty-row { text-align: center; color: #999; padding: 14px; font-style: italic; }
  .table-workshifts {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;

    th, td {
      border-bottom: 1px solid #eee;
      padding: 8px 6px;
      text-align: left;
    }
    th { color: #555; font-weight: 600; }
    .override-select {
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 4px 8px;
      width: 100%;
    }
  }
  .empty {
    text-align: center;
    color: #999;
    padding: 30px 0;
  }
  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px;
      font-weight: 600;
      color: #fff;
      border: none;
      height: 36px;
    }
    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px;
      font-weight: 600;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalApplyRecalcPoints.vue